import { useState, useMemo, useCallback } from 'react';
import { useData } from '../context/DataContext';

export function useGeneSearch() {
  const { data, resolveGene } = useData();
  const [query, setQuery] = useState('');

  const suggestions = useMemo(() => {
    if (!data || query.length < 1) return [];
    const q = query.toLowerCase();

    // Check aliases first
    const aliasMatches = [];
    if (data.aliases) {
      for (const [alias, canonical] of Object.entries(data.aliases)) {
        if (alias.startsWith(q) && data.expression[canonical]) {
          aliasMatches.push({ gene: canonical, matchedAs: alias });
        }
      }
    }

    // Direct gene matches
    const directMatches = data.geneList
      .filter(g => g.toLowerCase().startsWith(q))
      .slice(0, 15)
      .map(g => ({ gene: g, matchedAs: null }));

    // Merge, dedup by gene name
    const seen = new Set();
    const merged = [];
    for (const m of [...aliasMatches, ...directMatches]) {
      if (!seen.has(m.gene)) {
        seen.add(m.gene);
        merged.push(m);
      }
    }
    return merged.slice(0, 12);
  }, [data, query]);

  const resolve = useCallback((q) => {
    return resolveGene(q || query);
  }, [resolveGene, query]);

  return { query, setQuery, suggestions, resolve };
}
